<template>
  <div>
    <BasicDialog @close="closeDialog">
      <v-row>



        <v-col cols="12" class="d-flex flex-row justify-center align-center">
          <logo-background></logo-background>
          <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
            <img :src="AppConfigs.staticImages.FOLLOWONTIKTOK" alt="Follow us on TikTok" style="width: 70%; height: auto;">
            <img :src="AppConfigs.staticImages.PRIMARYCHECK" v-if="!isAvailable" style="position: absolute; top: -25%; left: -10%;">
          </div>
        </v-col>



        <v-col cols="12" class="d-flex flex-row justify-center text-h5 font-weight-bold">
          Follow on TikTok
        </v-col>



        <v-col cols="12" class="text-center">
          Follow us on TikTok and earn {{ coinsForFollowingOnTikTok }} coins
        </v-col>



        <v-col cols="12" class="d-flex flex-row justify-center">
          <v-btn rounded="pill" :disabled="!isAvailable"
            class="  button--primary text-h6 font-weight-medium px-6 py-6 d-flex"
            @click="followOnTikTok">
            Follow Now
          </v-btn>
        </v-col>



      </v-row>
    </BasicDialog>
  </div>
</template>



  
<script>

import { defineComponent } from 'vue';
import { AppConfigs } from "@/app.configs";
import { computed, inject, provide } from 'vue';
import { UserActivityStore } from '@/store/UserActivityStore';

import LogoBackground from "@/icons/LogoBackground.vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";

export default defineComponent({
  name: 'FollowUsOnTikTokDialog',
  components: {
    BasicDialog,
    LogoBackground,
  },
  setup(props, { emit }) {

    const inHouseTaskStore = UserActivityStore();
    let openDialog = inject('inHouseTaskOpenDialog');
    provide('openDialog', openDialog);

    const coinsForFollowingOnTikTok = computed(() => inHouseTaskStore.selectedInHouseTask.coins_amount);
    const isAvailable = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);

    const tikTokProfileUrl = 'https://www.tiktok.com/@bountyhunterapp';

    function closeDialog() {
      emit('close');
    }

    function followOnTikTok() {
      window.open(tikTokProfileUrl, '_blank');
      inHouseTaskStore.redeemCoinsForSelectedInHouseTask();
    }

    return {
      AppConfigs,
      closeDialog,
      isAvailable,
      followOnTikTok,
      coinsForFollowingOnTikTok,
    };
  },
});
</script>
